<template>
  <div class="content">
    <base-header class="pb-6" style="background-color: #248dc1 !important;">
      <div class="row align-items-center py-4">
        <div class="col-lg-7 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">{{$store.state.user.sponsor}} </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-5 col-5 text-right">
          <base-button ref="botonRefCreate" size="sm" type="neutral" v-if="$can('create', 'subcategorias')" @click="$emit('showModalCreateSubcategory')">Ingresar nueva subcategoría</base-button>
          <!--<base-button size="sm" type="neutral">Filters</base-button>-->
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Sucursal: {{$store.state.user.sponsor_branch}}</h3>
            <p class="text-sm mb-0">
              
            </p>
          </template>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Buscar...">
                </base-input>
              </div>
            </div>
            <div class="table-responsive">
                <el-table :data="queriedData"
                        row-key="id"
                        header-row-class-name="thead-light"
                        @sort-change="sortChange"
                        @selection-change="selectionChange">
                <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    v-bind="column"
                    :width="column.type == 'selection' ? '40px' : (column.label == 'id' ? '90px' : '200px')"
                >
                </el-table-column>
                <el-table-column min-width="180px" align="right" label="Acciones">
                    <div slot-scope="{$index, row}" class="d-flex">
                    
                    <base-button
                        @click.native="handleEdit($index, row)"
                        class="edit"
                        type="warning"
                        size="sm"
                        icon
                        v-if="$can('update', 'subcategorias')"
                    >
                        <i class="text-white ni ni ni-badge"></i>
                    </base-button>
                    <base-button
                        @click.native="handleDelete($index, row)"
                        class="remove btn-link"
                        type="danger"
                        size="sm"
                        icon
                    >
                        <i class="text-white ni ni-fat-remove"></i>
                    </base-button>
                    </div>
                </el-table-column>
                </el-table>
            </div>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Mostrando desde {{ from + 1 }} al {{ to }} de un total de {{ total }} registros

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} registros seleccionados
                </span>
              </p>

            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
      <!--Nuevo usuario Modal-->
      <form-create-subcategory  @successSending="fetchData" @showModalCreateSearchableAtribute="emitirAbrirAS"></form-create-subcategory>
      <edit-subcategory @showModalCreateSearchableAtribute="emitirAbrirAS" @successSending="fetchData"></edit-subcategory>
      <form-create-searchable-attribute @cerrarModalHijo="manejarClose" @successSending="manejarClose" ></form-create-searchable-attribute>
    </div></div 
></template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin'
import swal from 'sweetalert2';
import { Modal, BaseAlert } from '@/components';
import FormCreateSubcategory from './FormCreateSubcategory';
import EditSubcategory from './EditSubcategory';
import FormCreateSearchableAttribute from '@/views/SearchablesAttributes/FormCreateSearchableAttribute.vue';
import Fuse from 'fuse.js';

export default {
  mixins: [clientPaginationMixin],
  // En este mixins esta el atributo que se encarga del tamaño de la pagina
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert,
    FormCreateSubcategory,
    EditSubcategory,
    FormCreateSearchableAttribute
  },
  data() {
    return {
      propsToSearch: ['nombre'],
      tableColumns: [
      ],
      tableData: [],
      selectedRows: [],
      current_edited: undefined,
    };
  },
  methods: {
    emitirAbrirAS(from){
      console.log('emitirAbrirAS',from);
      this.$emit('showModalCreateSearchableAtribute2', from);
    },
    manejarClose(from){
        console.log('se cerro el modal create searchable attribute');
        
        
        switch(from){
          case 'create':
            this.$refs.botonRefCreate.$el.click();
            this.$emit('showModalCreateSubcategory');
            break;
          case 'edit':
            this.$emit('loadModalEditSubcategory',this.current_edited);
            break;
        }
        
    },
    handleEdit(index, row) {
     console.log('el index es: ', index, ' y el row.id es: ', row.id);
     this.current_edited = row.id;
     this.$emit('loadModalEditSubcategory', row.id);
    },
    handleDelete(index, row) {
      swal({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: 'Deleted!',
            text: `You deleted ${row.name}`,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    fetchData()
    {
      var vm = this;
      this.axios({
        url: 'api/test_list_subcategories',
        method: 'GET',

      }).then( response => {
        console.log(response.data);
        let columnas;
        if( response.data.data.length > 0 ) columnas = Object.getOwnPropertyNames(response.data.data[0]);
        vm.tableData = response.data.data;
        vm.propsToSearch = columnas;
        vm.tableColumns = [];
        vm.tableColumns.push({ type: 'selection' });
        columnas.forEach( item => {
          vm.tableColumns.push({ prop: item, label: item, sortable: true });
        } );
        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3
        });
      }).catch( error => {
        console.log('Error al ir  a buscar los usuarios');
        console.log(error); 
      })
    },
    openModalNuevoUsuario(){
      this.$emit
    },

  },
  mounted(){
    this.fetchData();
    console.log(this.$refs.botonRef);
  }
};
</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
</style>
